/**
 * @file: 分销2.0  编辑
 *
 * @author: FJJ
 * @history:
 * Date         Version Remarks
 * ============ ======= ======================================================
 * 2022/05/20      2.0     Second version
 * 2024.01.15       编辑不能调整分销类型，
 *
 * Copyright 2022, all rights reserved. Essa.cn
 * */

import React from "react";
import {Button, message, Modal, Spin, Divider, Space, Popconfirm, Switch} from 'antd';
import dayjs from "dayjs";
import AddAndEditForm from '../AddAndEditForm/index';
import ModalFormComponent from '@components/ModalForm/ModalForm';
import Lang from "@/components/Lang/Lang";
import CommonBreadcrumb from "@components/CommonBreadcrumb";
import DistributorAction from "../Distributor.action";
import IconEdit from '../components/IconEdit';
import {isEmpty} from '@utils/utils';
import qs from 'qs';
import "../DistributionCenter.less";
import "./Index.less";
class DistributionAccountInfo extends React.Component {
    static propTypes = {
    }
    static defaultProps = {
    };
    constructor(props) {
        super(props);
        this.state = {
            loading:false,
            sTypeFrom:'',// 来源页面:提成分销新增将传入 typefrom=orderCommission
            userInfo: {},
            userStatus:'',//用户状态
            showSuccess:false,
            fromData:{},
            showModal: false,
        }
    }
    /**
     * 加载
     * */
    loading(flag) {
        this.setState({
            loading: flag,
        });
    }
    /**
     * 请求
     * */
    postHttpAction(sUrl,data,callback){
        return $.ajax({
            url: sUrl,
            type:'post',
            dataType: "json",
            contentType: 'application/json',
            data:JSON.stringify(data),
            success:(res)=>{
                callback(res)
            }
        });
    }
    /**
     * 获取用户
     * */
    getInfo(){
    }
    onRefForm = (ref) =>  this.onRefFormFormatEdit = ref;
    /**
     * 点击确认时 获取表单数据
     *
     ***/
    async handleOK(){
        const res = await this.onRefFormFormatEdit.handleOK();
        if(res&&res.success){
            const { sTypeFrom, userStatus} = this.state;
            let postData = {
                ...res.data,
                type: sTypeFrom=='orderCommission'?"1":"0",//传入 typefrom=orderCommission 即为订单提成分销 0：注册提成 1：订单提成
            }
            const { roleUserId } = this.state;
            postData['distributorUserId'] = roleUserId;
            // 需要另外加入用户状态
            postData['status'] = userStatus;

            //   /data/service/fenxiao/basic-info/edit
            const sUrl = "/service/fenxiao/basic-info/edit";
            this.loading(true);
            this.postHttpAction(sUrl, postData, (resData) =>this.handleBackRes(resData));
        }
    }
    // 显示成功提示
    showSuccess(flag=false){
        this.setState({
            showSuccess: flag,
        })
        if(!false){
            this.loading(true)
            const {sTypeFrom} = this.state;
            window.location.href = sTypeFrom=='orderCommission'?"/distributor/extractDistributionList":'/distributor/list';//sTypeFrom?sTypeFrom:'/distributor/list';
        }
    }
    /**
     * 重置密码
     * */
    reSetPassword(userInfo={}){
        this.setState({
            showModal:true,
            title:{
                cnTitleId:'ChongZhiMiMa',
                cnTitle:'重置密码',
            },
            fromInitialValues: userInfo,
            options:[
                {
                    name:'distributorUserId',
                    title:'ID',
                    required: true,
                    disabled:true,
                    hidden:true,
                },
                {
                    name:'password', // 新密码 todo 密码强度
                    cnTitleId:'XinMiMa',
                    cnPlaceholderId:'XinMiMa',
                    required: true,
                    type:'Password'
                },
            ],
        })
    }

    /**
     * 复制
     **/
    copyText(fromData={}) {
        {/* 账号 密码*/}
        const text =__getServerLanguage("ZhangHao")+'：'+ fromData.mobile+'，' + __getServerLanguage("MiMa")+'：'+fromData.mobile;
        let key = 'execCommandAgent';
        let agent = document.getElementById(key);
        if (!agent) {
            const e = document.createElement('input');
            e.id = key;
            e.style.position = 'absolute';
            e.style.top = '-40px';
            e.style.left = 0;
            document.body.appendChild(e);
            agent = document.getElementById(key);
        }
        agent.value = text;
        agent.select();
        document.execCommand("Copy"); // 执行浏览器复制命令
        message.success(Lang({id:"FuZhiChengGong",default:"复制成功"}))
    }
    // 设置 当前
    getUser(iId=''){
      if(!isEmpty(iId)){
          this.setState({
              roleUserId: iId
          })
          const postData={
              distributorUserId: iId
          }
          this.loading(true);
          DistributorAction.getDistributorInfo(postData).then(res=>this.handleRes(res.data)).catch(err=>this.handleRes(err));
      }
    }
    handleRes(res){
        const {success,valid,model} = res;
        if(success&&valid){
            let initInfo = {...model}
            const contract= model.contract||{};
            if(contract.effectiveStartTime&&contract.effectiveEndTime){ // 有效期
                contract['effectiveTime'] = [dayjs(contract.effectiveStartTime),dayjs(contract.effectiveEndTime)];
            }
            if(initInfo.cardFileId&&initInfo.cardFileUrl){ //证件照片
                const obj ={
                    fileId: initInfo.cardFileId||'',
                    fileUrl: initInfo.cardFileUrl||'',
                    fileName:initInfo.cardFileUrl||'',
                }
                initInfo['cardFile'] = [obj]
            }
            if(initInfo.photoFileId&&initInfo.photoFileUrl) { //头像
                const map ={
                    fileId: initInfo.photoFileId || '',
                    fileUrl: initInfo.photoFileUrl || '',
                    fileName: initInfo.photoFileUrl || '',
                }
                initInfo['photoFile'] = [map]
            }
            if(initInfo.saleMarketId){
                initInfo['saleMarketId'] = initInfo.saleMarketId+''; //区域
            }
            this.setState({
                userInfo:initInfo,
                userStatus: initInfo.status,
            })
        }else if(res.message)message.warning(res.message);
        this.loading(false);
    }
    /**
     * 保存弹窗数据
     *
     **/
    handleSave(dat={}){
        this.loading(true);
        const {roleUserId} = this.state;
        const postData = {
            id: roleUserId,
            password: dat.password
        }
        DistributorAction.resetPassword(postData).then(res=>this.handleBackRes(res.data,Lang({id:'MiMaChongSheChengGong',default: "密码重设成功",})));
    }
    /**
     * 删除
     * */
    handleDelete(){
        const {roleUserId} = this.state;
        const postData={
            id: roleUserId
        }
        DistributorAction.delete(postData).then(res=>this.handleBackRes(res.data)).catch(err=>this.handleRes(err));
    }
    handleBackRes(res,successMsg=''){
        const {success,valid}= res;
        this.loading(false);
        if(success&&valid){
            message.success(successMsg||Lang({id:'CaoZuoChengGong',default: "操作成功"}))
            setTimeout(()=>{
                // 保存成功 改为跳回列表
                // window.location.href = '/distributor/list';
                const { sTypeFrom } = this.state;
                this.props.history.push(sTypeFrom=='orderCommission'?"/distributor/extractDistributionList":'/distributor/list')
            },400)
            this.handleCancelPop()
        }else if(res.message){
            message.warning(res.message);
        }else message.warning(Lang({id:'CaoZuoShiBai',default: "操作失败",}));
    }
    /**
     * 关闭弹窗
     *
     **/
    handleCancelPop(){
        this.setState({
            showModal:false,
            title:{},
            fromInitialValues:{},
        })
    }
    setFieldsValue(dat){
        const {userInfo} = this.state;
        const newUserInfo = {
            ...userInfo,...dat
        }
        this.setState({
            userInfo: newUserInfo,
        })
    }
    /**
     * 状态
     * */
    setSwitchStatusField(value=''){
        this.setState({
            userStatus: value
        })
    }
    renderSwitch(initialValues={},valueStatus=''){
        // 字典:fx_user_status; NOT_ENABLED:未激活 VALID:启用 INVALID:禁用
        // const valueStatus = initialValues['status'];
        const types = __getDictMap('fx_user_status')||{};
        let showStatus = ''
        if(isEmpty(valueStatus)||valueStatus=='NOT_ENABLED'){
            showStatus =  types['NOT_ENABLED'];
        }
        const option = {
            type:'OnlyRender',
            name:'status',
            cnTitle:'账号状态',
            cnTitleId:'ZhangHaoZhuangTai',
            showTitle: true,
            onlyRender:(showStatus?showStatus:(valueStatus=='VALID'&&initialValues.status=='VALID'&&(initialValues.notShippedBuyerCodes||(initialValues.balance&&initialValues.balance>0))?<Popconfirm
                title={(<div className={'distributor-status-confirm'}>
                    <p>{Lang({id:'ShiFouYaoTingYongGaiFenXiaoShangMa',default:'是否要停用该分销商吗'})+'?'}</p>
                    {/*{initialValues.notShippedBuyerCodes&&<p dangerouslySetInnerHTML={{ __html: __getServerLanguage('XiaJiYongHuDingDanHaiMeiChuHuo ',`<span>${initialValues.notShippedBuyerCodes}</span>`,) }}></p>}*/}
                    {/* 下级用户{0}订单还没出货 */}
                    {initialValues.notShippedBuyerCodes&&<p className={"red"}><Lang id={'XiaJiYongHuDingDanHaiMeiChuHuo'} params={[initialValues.notShippedBuyerCodes]}>下级用户{initialValues.notShippedBuyerCodes}订单还没出货</Lang></p>}
                    {(initialValues.balance&&initialValues.balance>0)?<p className={"red"}>
                        {Lang({id:'FenXiaoShangHaiYouDaiJieSuanJieSuanZhongDeJinE',default:'分销商还有待结算/结算中的金额'})}</p>:""}
                </div>)}
                icon={null}
                okText={Lang({id:'queren',default:'确认'})}
                cancelText={Lang({id:'QuXiao',default:'取消'})}
                onConfirm={()=>this.setSwitchStatusField('INVALID')}>
                <Switch checked={valueStatus=='VALID'}/><span className={"margin-left-5"}>{types[valueStatus]}</span>
            </Popconfirm>:<div><Switch onChange={(checked)=>this.setSwitchStatusField(checked?'VALID':'INVALID')}
                                       checked={valueStatus=='VALID'}/><span className={"margin-left-5"}>{types[valueStatus]}</span></div>)),
        }
        return option
    }
    init(){
        const { search } = this.props.location;
        const list = qs.parse(search)||{};
        const sType =list['typefrom'];
            this.setState({
                sTypeFrom:sType,
            })
        this.getUser(list['?id'])
    }
    componentWillMount() {
        this.init()
    }
    componentWillUnmount(){
        this.setState = (state, callback) => {
            return;
        }
    }
    render() {
        const { loading,userInfo,showModal,userStatus,options,title,fromInitialValues, showSuccess, fromData,sTypeFrom} = this.state;
        // 默认 注册分销，传入typefrom=orderCommission 即为提成分销
        const currPageName = sTypeFrom=='orderCommission'?Lang({id: "TiChengFenXiaoShang",default: "提成分销商"}):Lang({id: "ZhuCeFenXiaoShang",default: "注册分销商"});
        return (<Spin spinning={loading}>
            <CommonBreadcrumb list={[
                { name:currPageName,link:sTypeFrom=='orderCommission'?"/distributor/extractDistributionList":'/distributor/list'},
                {name: Lang({id:"BianJiZhangHao", default:"编辑账号"})}]}></CommonBreadcrumb>
            <div className="distribution distributionEdit black89">
                <div className={"font_16 fw_700"}>{Lang({id:"BianJiZhangHao", default:"编辑账号"})}（{currPageName}）</div>
                {userInfo.distributorUserId?<>
                    <div className={"lineBorder mt_12"}>
                        {/*   普通 表单 start */}
                        <AddAndEditForm onRef={this.onRefForm}
                                                                     typeFrom={sTypeFrom} // 订单提成 为 sTypeFrom：订单提成 'orderCommission' ，注册提成：空， 不显示合同
                                                                     typeOption={"edit"} // 操作类型:  edit 编辑状态
                                                                     userInfo={userInfo}
                                                                     loading={loading}
                                                                     renderSwitch={()=>this.renderSwitch(userInfo,userStatus)} />
                        {/*   普通 表单 end */}
                    </div>
                    {/* 操作 */}
                    <Space>
                        <Button type="primary" loading={loading}
                                onClick={()=>this.handleOK()}>{__getServerLanguage("BaoCun")}</Button>
                        {/* 重置密码 */}
                        <Button danger loading={loading}
                                onClick={()=>this.reSetPassword(userInfo)}>{__getServerLanguage("ChongZhiMiMa")}</Button>
                        {/* 删除 */}
                        {userInfo.status=='NOT_ENABLED'&&<Button loading={loading} onClick={()=>this.handleDelete()}>{__getServerLanguage("ShanChu")}</Button>}
                    </Space>
                    {/* 操作 end*/}
                </>:null}
                {showModal&&<ModalFormComponent loading={loading}
                                                showModal={showModal}
                                                title={title}
                                                options={options}
                                                saveFormValue={this.handleSave.bind(this)}
                                                initialValues={fromInitialValues}
                                                handleCancel={this.handleCancelPop.bind(this)} />}
                {showSuccess&&<Modal
                    open={showSuccess}
                    className={"pop-success-add"}
                    footer={null}
                    onCancel={()=>this.showSuccess(false)}>
                    <div className={"top-tips"}>
                        <IconEdit type="successIcon" />
                        {/* 保存成功 */}
                        <h3>{__getServerLanguage("BaoCunChengGong")}</h3>
                        {/* 账号 */}
                        <p>{__getServerLanguage("ZhangHao")}：{fromData.mobile}</p>
                        {/*  密码 MiMa */}
                        <p>{__getServerLanguage("MiMa")}：{fromData.password}</p>
                    </div>
                    <Space className={"footer-btn"}>
                        <Button type="primary" key="console"  onClick={()=>this.copyText(fromData)}>
                            {__getServerLanguage("FuZhiZhangHaoMiMa")}
                        </Button>
                        <Button className={"margin-left-10"} onClick={()=>this.showSuccess(false)}>
                            {__getServerLanguage("FanHui")}
                        </Button>
                    </Space>
                </Modal>}
            </div>
        </Spin>);
    }
}

export default DistributionAccountInfo;
